<template>
       <v-dialog
        v-model="dialogeditimage"
        width="40%"
        lazy
        persistent
        @keydown.esc="closedialogEditImage()"
      >
        <v-card style="background-color:black ;">
        <v-toolbar dark>
            <v-toolbar-title>แก้ไขรูปโปรไฟล์</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
            <div class="avatar">
              <vue-avatar
                :width="300"
                :height="300"
                :rotation="rotation"
                :scale="scale"
                :border="0"
                ref="vueavatar"
                style="text-align: center;"
                @vue-avatar-editor:image-ready="onImageReady"
                :image="filename"
                >
              </vue-avatar>
                </div>
                <v-container>
                  <v-slider
                    dark v-model="scale" label="Zoom :" min=1 max=3 step=0.02 thumb-label="always" ticks
                  ></v-slider>
                  <v-slider
                    dark v-model="rotation" label="Rotation :" min=0 max=360 step=1 thumb-label="always"ticks
                  ></v-slider>
                </v-container>
              <!----------------------------------------------------------------------->
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              flat
              dark
              @click="savePicturecrop"
            >
              save
            </v-btn>
            <v-btn
              flat
              dark
              @click="closedialogEditImage()"
            >
              close
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-dialog>

</template>

<script>
import {VueAvatar} from 'vue-avatar-editor-improved'
export default {
  props: {
    dialogeditimage: Boolean
    // filename: String
  },
  components: {
    VueAvatar
  },
  data: () => ({
    scale: 1,
    rotation: 0,
    coordinates: {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    },
    newWidth: 0,
    newHeight: 0,
    defaultPic: '',
    model: 'tab-1',
    filename: '',
    cropper: '',
    token: '',
    // uploadIm: true,
    cropshow: true,
    filter: false,
    filterId: 0,
    preview: '',
    leftArrow: false,
    rightArrow: false,
    filterlist: [
      {id: 0, name: 'None'},
      {id: 1, name: 'Brannes'},
      {id: 2, name: 'Inkwell'},
      {id: 3, name: 'Lo-fi'},
      {id: 4, name: 'Nashville'},
      {id: 5, name: 'Toaster'},
      {id: 6, name: 'Walden'},
      {id: 7, name: 'Willow'},
      {id: 8, name: 'X-pro-II'}
    ]
  }),
  created () {
    this.token = localStorage.getItem('tokenuser')
    this.filename = localStorage.getItem('profilepicture')
  },
  watch: {
    filename () {
      this.cropper = this.filename
    },
    dialogeditimage () {
      // console.log('-----------------------')
      if (this.dialogeditimage) {
        this.$refs.vueavatar.loadImage(this.filename)
      }
    }
  },
  methods: {
    onImageReady () {
      this.scale = 1
      this.rotation = 0
    },
    closedialogEditImage () {
      var canvas = document.getElementById('avatarEditorCanvas')
      var context = canvas.getContext('2d')
      context.clearRect(0, 0, canvas.width, canvas.height)
      this.$refs.vueavatar.redraw()
      this.scale = 1
      this.rotation = 0
      this.$emit('closeDialogEdit', false)
    },
    onChange ({ coordinates, canvas }) {
      // this.coordinates = coordinates
      this.cropper = canvas.toDataURL()
      this.preview = canvas.toDataURL()
      this.filterId = 0
    },
    b64toBlob (dataURI) {
      var byteString = atob(dataURI.split(',')[1])
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
        // console.log(ia[i])
      }
      return new Blob([ab], { type: 'image/jpeg' })
    },
    savePicturecrop () {
      var img = this.$refs.vueavatar.getImageScaled()
      img = img.toDataURL()
      var uploadFile = new FormData()
      // this.cropper = this.filterss
      var blob = this.b64toBlob(img)
      // console.log(this.selectFile)
      uploadFile.append('file', blob, 'file.jpg')
      uploadFile.append('tokenuser', this.token)
      // uploadFile.entries().next().value
      this.$http.post(process.env.APImanage + '/setpictureprofileuser', uploadFile).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          // console.log('response.body')
          // alert('mmm')
          this.$swal(
            '',
            'เปลี่ยนรูปประจำตัวสำเร็จ.',
            'success'
          )
          this.cropper = response.body.filename
          // this.returnresponse = response.body
          this.$store.dispatch('myProfile', response.body.filename)
          localStorage.setItem('profilepicture', response.body.filename)
          this.filename = localStorage.getItem('profilepicture')
          // console.log(response)
          // this.myprofile(response.body.filename)
          this.defaultPic = this.filename
          this.closedialogEditImage()
        }
      }, (response) => {
        console.log('error')
      })
    },
    changeFilter (id) {
      var canvas = document.getElementById('myCanvas')
      var ctx = canvas.getContext('2d')
      var image = document.getElementById('scream')
      this.filterId = id
      // console.log(this.filterId)
      if (id === 1) {
        ctx.filter = 'sepia(0.5) contrast(1.4)'
      } else if (id === 2) {
        ctx.filter = 'sepia(0.3) contrast(1.1) brightness(1.1) grayscale(1)'
      } else if (id === 3) {
        ctx.filter = 'saturate(1.1) contrast(1.5)'
      } else if (id === 4) {
        ctx.filter = 'sepia(0.2) contrast(1.2) brightness(1.05) saturate(1.2)'
      } else if (id === 5) {
        ctx.filter = 'contrast(1.5) brightness(0.9)'
      } else if (id === 6) {
        ctx.filter = 'brightness(1.1) hue-rotate(-10deg) sepia(0.3) saturate(1.6)'
      } else if (id === 7) {
        ctx.filter = 'grayscale(0.5) contrast(0.95) brightness(0.9)'
      } else if (id === 8) {
        ctx.filter = 'sepia(0.3)'
      } else {
        this.filterId = 0
        ctx.filter = 'none'
      }
      ctx.drawImage(image, 0, 0, 200, 200)
      this.cropper = canvas.toDataURL()
      image = document.getElementById('scream')
      // ctx.filter = 'none'
    },
    previewTest (data) {
      this.selectFile = data.target.files[0]
      this.defaultPic = URL.createObjectURL(this.selectFile)
      console.log(this.defaultPic)
    },
    uppic () {
      // console.log('uppic')
      // console.log('uploadpicprofilechat')
      // ga('send','event','Edit Profile Engagement','Click Navbar','Button=Photo')
      // $('#uploadpicprofilechat').click()
      document.getElementById('uploadpicprofilechat').click()
      // this.$emit('profilePic', this.filename)
      // document.getElementById('uploadpicprofilechat').click()
    },
    uppictest () {
      // console.log('uppictest')
      // console.log('uploadpicprofilechat')
      // ga('send','event','Edit Profile Engagement','Click Navbar','Button=Photo')
      $('#uploadpicprofilechat').click()
      // document.getElementById('uploadpicprofilechat').click()
    },
    goLeft () {
      document.getElementById('containerClass').scrollLeft -= 20
    },
    goRight () {
      document.getElementById('containerClass').scrollLeft += 20
    },
    defaultSize () {
      return {
        width: 500,
        height: 500
      }
    }
  },
  computed: {
  }
}
</script>

<style scoped>
.Brannes{
  filter: sepia(0.5) contrast(1.4) ;
  width: 100px;
  height: 100px;
}
.Inkwell{
  filter: sepia(0.3) contrast(1.1) brightness(1.1) grayscale(1) ;
  width: 100px;
  height: 100px;
}
.Lo-fi{
  filter: saturate(1.1) contrast(1.5) ;
  width: 100px;
  height: 100px;
}
.Nashville{
  filter: sepia(0.2) contrast(1.2) brightness(1.05) saturate(1.2) ;
  width: 100px;
  height: 100px;
}
.Toaster{
  filter: contrast(1.5) brightness(0.9) ;
  width: 100px;
  height: 100px;
}
.Walden{
  filter: brightness(1.1) hue-rotate(-10deg) sepia(0.3) saturate(1.6) ;
  width: 100px;
  height: 100px;
}
.Willow{
  filter: grayscale(0.5) contrast(0.95) brightness(0.9) ;
  width: 100px;
  height: 100px;
}
.X-pro-II{
  filter: sepia(0.3) ;
  width: 100px;
  height: 100px;
}
.None{
  filter: none ;
  width: 100px;
  height: 100px;
}
.Selectedfilter {
  border: white 2px solid !important;
  width: 110px;
  height: 110px;
}
.center-preview{
  display: flex;
  justify-content: center;
}
.center-preview2{
  display: flex;
  justify-content: center;
  height: 158px !important;
}
.center-options{
  display: flex;
  justify-content: center;
  /* margin-top: 50px;
  margin-bottom: 20px; */
}
.centerslide{
  margin-left: 12px;
  margin-right: 12px;
}
.SettingImgWrap {
    display: inline-block;
    position: relative;
    border-radius: 40px;
    overflow: hidden;
}
.imagePreviewWrap{
  margin-top: 5px;
}
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.container {
  position: relative;
  text-align: center;
  color: white;
  background-color: rgba(0,0,0,0.2);

}
/* .tabStyle { */
  /* margin-top: 10px; */
/* } */
.arraowLeft {
  position: absolute;
  left: 10px;
  top: 74%;
  /* background-color: thistle; */
  color: wheat;
}

.arraowRight {
  position: absolute;
  right: 10px;
  top: 74%;
  /* background-color: thistle; */
  color: wheat;
}
.btn-label{
  border: white 2px solid;
}
/* .v-card {
  border: yellow 2px solid ;
} */
.testScroll::-webkit-scrollbar{
  display: none;
}
.vue-advanced-cropper {
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    max-height: 100%;
    max-width: 100%;
    direction: ltr;
}
.chooseFilter{
  background-color: transparent;
  width: 100px;
  height: 100px;
  margin-left:10px;
  margin-right: 15px;
  cursor:pointer
}
.buttonProfilePic{
  color: white;
  border: white 2px solid;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.buttonProfilePic2{
  color: white;
  border: white 2px solid;
}
.avatar {
margin-top: 20px;
}
>>>canvas {
  width: 200px !important;
  height: 200px !important;
  border: 2px white solid;
  border-radius: 20px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/DialogCropImage.vue